<template>
  <div class="home" v-if="!fetching">
    <div class="header">
      <div class="validity">
        出游卡权益有效期至{{
          card_info.card_expiry_date | formatDate("YYYY.MM.DD")
        }}
      </div>
    </div>
    <div class="benefit-body">
      <div class="benefit-list" v-if="card_info.card_status === 'active'">
        <div
          v-for="(item, seq) in benefit_list"
          class="benefit-item"
          :key="item.type"
        >
          <van-image
            class="benefit-item-icon"
            mode="aspectFit"
            :src="item.icon_url"
          />
          <div class="benefit-item-text">
            <div class="title" v-html="getRichText(item.title)"></div>
            <div class="subtitle van-multi-ellipsis--l3">
              {{ item.subtitle }}
            </div>
          </div>
          <div
            v-ans="{
              event_id: 'benefit_list_click',
              sequence: seq,
              spu_id: item.type,
              benefit_type: item.type,
              spu_name: item.title,
            }"
            class="benefit-item-btn"
            @click="jump(item)"
          >
            去使用
          </div>
          <div class="times">
            可领取 {{ item.amount + item.amount_reserved }} 次
          </div>
        </div>
      </div>
      <div v-if="card_info.card_status === 'expired'" class="card-past">
        您的权益已过期
      </div>
      <div v-if="card_info.card_status === 'refund'" class="card-past">
        您的权益已退款
      </div>
      <section class="page-footer">
        <router-link
          class="order"
          to="/order"
          v-ans="{ event_id: 'member_to_order_click' }"
          ><svg-icon icon-class="leiniao-order" />我的订单</router-link
        >
        <router-link
          class="service"
          to="/service"
          v-ans="{ event_id: 'member_to_service_click' }"
          ><svg-icon icon-class="leiniao-service" />在线客服</router-link
        >
      </section>
    </div>
  </div>
</template>

<script>
import { getUserBenefit } from "@/apis/home";
import { mapMutations, mapState } from "vuex";

import { jsonSafeParse } from "@/utils";

export default {
  name: "index",
  components: {},
  data() {
    return {
      is_prod: process.env.VUE_APP_RUNTIME_ENV === "production",
      card_info: {
        current_cycle_expired_date: "",
        card_expiry_date: "",
        card_status: "expired",
      },
      benefit_list: [],
      fetching: true,
    };
  },

  methods: {
    ...mapMutations(["changeState"]),
    async jump(item) {
      this.$router.push(`/benefitDetail?benefit_type=${item.type}`);
    },
    getRichText(title) {
      const RED_TITKL_TEXT_ENUM = jsonSafeParse(
        this.$getConfigValue("RED_TITKL_TEXT_ENUM")
      );
      let result = title;
      RED_TITKL_TEXT_ENUM.forEach((item) => {
        if (title.indexOf(item) > -1) {
          result = title.replace(
            item,
            `<span style="color: #FF5001">${item}</span>`
          );
        }
      });
      return result;
    },
  },
  async mounted() {
    const loading = this.$loading();
    try {
      const res = await getUserBenefit();
      if (res.data.benefit_order) {
        const orders = res.data.benefit_order.split(",");
        res.data.benefit_list.sort((a, b) => {
          return orders.indexOf(a.type) - orders.indexOf(b.type);
        });
      }
      this.benefit_list = (res.data.benefit_list || []).filter((r) => r.title);
      this.card_info = res.data;
    } finally {
      this.fetching = false;
      loading.clear();
    }
  },
  computed: {
    ...mapState([
      "namespace",
      "namespaceInfo",
      "userInfo",
      "benefit_source",
      "package_name",
    ]),
  },
};
</script>
<style scoped lang="less">
.home {
  background-color: #ff6412;
  min-height: 100vh;
  padding-bottom: 20px;
  box-sizing: border-box;
}

.header {
  position: relative;
  height: 178px;
  background: url("~@/assets/images/kukai_header.png") no-repeat;
  background-size: cover;
}
.validity {
  position: absolute;
  left: 34px;
  top: 88px;
  font-size: 11px;
  color: #ff660e;
}
.benefit-body {
  position: relative;
  z-index: 1;
  margin: -10px 15px 0;
  padding-top: 10px;
  background-color: #fff;
  border-radius: 12px;
}
.benefit-list {
  position: relative;
  padding-left: 8px;
  padding: 0 10px 0 15px;
}
.benefit-item {
  position: relative;
  padding: 0 10px 0 16px;
  height: 72px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  background: url("~@/assets/images/kukai_benefit_item_bg.png") no-repeat;
  background-size: cover;
  & + & {
    margin-top: 8px;
  }
}
.times {
  position: absolute;
  left: -10px;
  top: 0;
  width: 70px;
  height: 23px;
  line-height: 20px;
  color: #fff;
  background: url("~@/assets/images/kukai_benefit_tag.png") no-repeat;
  background-size: 100%;
  font-size: 10px;
  text-align: center;
}
.benefit-item-text {
  margin-right: 12px;
  flex: 1;
  .title {
    font-weight: bold;
    font-size: 14px;
    color: #202437;
    margin-bottom: 2px;
  }
  .subtitle {
    font-size: 10px;
  }
}
.benefit-item-icon {
  width: 45px;
  height: 45px;
  flex-shrink: 0;
  margin-right: 10px;
}

.benefit-item-btn {
  width: 60px;
  height: 23px;
  background: #fff;
  border-radius: 23px;
  color: #ec4d25;
  line-height: 23px;
  text-align: center;
  flex-shrink: 0;
}

.page-footer {
  display: flex;
  align-items: center;
  padding: 0 15px 0;
  margin-top: -10px;
  height: 92px;
  opacity: 0.82;
  box-sizing: border-box;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  background: url("~@/assets/images/kukai_footer_bg.png") no-repeat;
  background-size: 100%;

  .svg-icon {
    font-size: 20px;
    margin-right: 6px;
    color: #fd4c14;
    vertical-align: -4px;
  }
  .order,
  .service {
    font-size: 15px;
    border-radius: 42px;
    height: 42px;
    line-height: 42px;
    width: 50%;
    border: 1px solid #ebebeb;
    color: #202437;
    text-align: center;
    line-height: 40px;
    vertical-align: -4px;
    font-weight: bold;
  }
  .order {
    margin-right: 10px;
  }
}

.card-past {
  text-align: center;
  height: 195px;
  background-color: #fff;
  border-radius: 5px;
  margin: 12px 12px 20px;
  overflow: hidden;
  p {
    text-align: center;
    line-height: 1.5;
    color: #404040;
    margin-top: 17px;
  }
  /deep/ .van-image {
    width: 80px;
    height: 80px;
    margin: 56px auto 14px;
  }
}
</style>